(function () {
  angular.module("akitabox.ui.dialogs.schedule.reopen", [
    "akitabox.core.constants",
    "akitabox.core.services.schedule",
    "akitabox.core.toast",
  ]);
})();
